import {FC, useMemo} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'

const AddAction: FC<{url: string; title?: string}> = ({url, title = 'GENERAL.ADD'}) => {
  const intl = useIntl()
  const id = `${Math.random()}`

  const titleHasTranslation = title ? !!intl.messages[title] : false

  const renderTooltip = useMemo(() => {
    return (
      <Tooltip id={`tooltip-${id}`}>{titleHasTranslation ? intl.$t({id: title}) : title}</Tooltip>
    )
  }, [title, id, intl, titleHasTranslation])

  return (
    <OverlayTrigger overlay={renderTooltip}>
      <Link to={url} className='btn btn-sm btn-light-primary'>
        <span className='fas fa-plus me-1' /> {intl.$t({id: title})}
      </Link>
    </OverlayTrigger>
  )
}

export default AddAction
